var _defs, _rect, _rect2, _path, _g, _path2, _path3, _path4, _circle, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateNoOffers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3,.cls-5,.cls-6,.cls-7{fill:#0089e5;}.cls-3{opacity:0.2;}.cls-4{clip-path:url(#clip-path);}.cls-5{opacity:0.4;}.cls-6{opacity:0.3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.9,77.5l-86.1-58c-2.33-9-3.49-10.18,3.49-9.59h171c7.85,0,7.56,7,3.49,9.59l-86.1,58A5.23,5.23,0,0,1,87.9,77.5Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty State - Proposta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.8,
    y: 9.81,
    width: 178.02,
    height: 105.88,
    rx: 3.41,
    ry: 3.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.8,
    y: 9.81,
    width: 178.02,
    height: 105.88,
    rx: 3.89,
    ry: 3.89
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.81,52.28l89,59.92a3.5,3.5,0,0,1-3.49,3.49H5.29A3.5,3.5,0,0,1,1.8,112.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.8,
    y: 9.94,
    width: 178.02,
    height: 105.88,
    rx: 3.5,
    ry: 3.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.81,52.28l89,59.92a3.5,3.5,0,0,1-3.49,3.49H5.29A3.5,3.5,0,0,1,1.8,112.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.9,71.26,1.8,13.3A3.5,3.5,0,0,1,5.29,9.81h171a3.5,3.5,0,0,1,3.49,3.49l-86.1,58A5.19,5.19,0,0,1,87.9,71.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.9,71.26,1.8,13.3A3.5,3.5,0,0,1,5.29,9.81h171a3.5,3.5,0,0,1,3.49,3.49l-86.1,58A5.19,5.19,0,0,1,87.9,71.26Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 174.28,
    cy: 15.72,
    r: 15.72
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.1,15.74q0,4.36-1.43,6.46a5,5,0,0,1-4.4,2.1,4.88,4.88,0,0,1-4.35-2.17q-1.47-2.16-1.47-6.39,0-4.41,1.43-6.5a5.53,5.53,0,0,1,8.74.1C179.61,10.79,180.1,12.93,180.1,15.74Zm-8.15,0a13,13,0,0,0,.53,4.39,1.85,1.85,0,0,0,3.56,0,12.5,12.5,0,0,0,.55-4.38,12.52,12.52,0,0,0-.55-4.4A1.85,1.85,0,0,0,174.27,10a1.83,1.83,0,0,0-1.78,1.34A12.82,12.82,0,0,0,172,15.74Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoOffers);
export default __webpack_public_path__ + "static/media/empty-state-no-offers.a83d8a1a.svg";
export { ForwardRef as ReactComponent };